import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import BackToTop from '@/components/feature/BackToTop';
import Seo from '@/components/feature/Seo';
import Hero from '@/pages/home/components/Hero';
import HotBoard from '@/pages/home/components/HotBoard';
import CategoryGrid from '@/pages/home/components/CategoryGrid';
import LatestFeed from '@/pages/home/components/LatestFeed';
import Voices from '@/pages/home/components/Voices';
import FaqSection from '@/pages/home/components/FaqSection';
import { hotArticles } from '@/mocks/articles';
import { faqs } from '@/mocks/faqs';

const homeJsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '反差现场',
    description:
      '聚焦网红台前幕后反差的中文内容站，集中呈现直播录制、台下偶遇、粉丝爆料与私下被拍的现场素材。',
    inLanguage: 'zh-CN',
  },
  {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    name: '本周热搜反差榜',
    itemListElement: hotArticles.map((article, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      url: `/article/${article.slug}`,
      name: article.title,
    })),
  },
  {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((item) => ({
      '@type': 'Question',
      name: item.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.a,
      },
    })),
  },
];

export default function Home() {
  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <Seo
        title="反差现场｜网红反差台上台下两副面孔，真实性格尽收眼底"
        description="反差现场聚焦网红反差，把直播录制、台下偶遇、粉丝爆料与私下被拍的画面集中呈现。台上营业状态与私下真实性格放在一起对比，适合想看真实一面的观众与扒皮常客。"
        keywords="网红反差,网红反差台上台下,网红反差真实性格,网红反差镜头前后"
        path="/"
        jsonLd={homeJsonLd}
      />
      <SiteHeader overlay />
      <main className="flex-1">
        <Hero />
        <HotBoard />
        <CategoryGrid />
        <LatestFeed />
        <Voices />
        <FaqSection />
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}